(() => {
  const roots = () => document.querySelectorAll('.ProductBoxExpanded[data-pack-price]');
  const scope = root => root.closest('product-info') || root.closest('[id^="MainProduct-"]') || root.parentElement;
  const number = value => Number(String(value).replace(/,/g, ''));
  const text = (root, selector, value) => { const el = root.querySelector(selector); if (el) el.textContent = value; };
  function render(root, fromArea) {
    const parent = scope(root);
    const area = root.querySelector('.EnterSQF input');
    const quantity = parent.querySelector('input[name="quantity"]');
    const coverage = number(root.dataset.packCoverage);
    const price = number(root.dataset.packPrice) / 100;
    if (!quantity || !(coverage > 0) || !Number.isFinite(price)) return;
    const waste = root.querySelector('.calc-toggle').dataset.waste === 'true';
    const requested = number(area.value);
    if (fromArea && area.value.trim() && requested > 0 && Number.isFinite(requested)) {
      quantity.value = Math.ceil(Math.round(requested * (waste ? 1.08 : 1) * 1000000) / 1000000 / coverage);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const boxes = number(quantity.value);
    const summary = root.querySelector('.ProductSummary');
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency }).format(value);
    const display = parent.querySelector('.dotfloor-price-wrap');
    if (display) {
      text(display, '.dotfloor-price-sqft > span', money(price / coverage));
      text(display, '.dotfloor-price-box > span', money(price));
      text(display, '.dotfloor-price-coverage > span', coverage);
      const meta = display.querySelector('.dotfloor-price-meta'); if (meta) meta.style.display = '';
      display.style.visibility = 'visible';
    }
    if (!area.value.trim() || !(requested > 0) || !Number.isFinite(requested)) {
      summary.style.display = 'none';
      return;
    }
    text(root, '.totalsqf span', Number((boxes * coverage).toFixed(3)));
    text(root, '.totalbox', `${boxes} ${boxes === 1 ? root.dataset.boxLabel : root.dataset.boxesLabel}`);
    text(root, '.sqf span', money(price / coverage));
    text(root, '.box span', money(price));
    text(root, '.waste span', waste ? Number((requested * 0.08).toFixed(3)) : 0);
    text(root, '.ordertotal', `${root.dataset.totalLabel}: ${money(boxes * price)}`);
    summary.style.visibility = 'visible'; summary.style.display = 'block';
  }
  function init() {
    roots().forEach(root => {
      const toggle = root.querySelector('.calc-toggle');
      if (toggle) setWaste(toggle, toggle.dataset.waste);
      render(root, false);
    });
  }
  document.addEventListener('input', event => {
    const root = event.target.closest('.ProductBoxExpanded[data-pack-price]');
    if (root && event.target.matches('.EnterSQF input')) render(root, true);
  });
  document.addEventListener('change', event => {
    if (event.target.matches('input[name="quantity"]')) roots().forEach(root => { if (scope(root).contains(event.target)) render(root, false); });
  });
  function setWaste(toggle, value) {
    const active = String(value === true || value === 'true');
    toggle.dataset.waste = active;
    toggle.querySelectorAll('.calc-toggle__opt').forEach(option => {
      const on = option.dataset.value === active;
      option.classList.toggle('is-active', on);
      option.setAttribute('aria-checked', String(on));
      // 只有选中项可 Tab 进入，方向键在同组内移动
      option.tabIndex = on ? 0 : -1;
    });
  }

  document.addEventListener('click', event => {
    const option = event.target.closest('.ProductBoxExpanded[data-pack-price] .calc-toggle__opt');
    if (!option) return;
    const toggle = option.closest('.calc-toggle');
    const root = toggle.closest('.ProductBoxExpanded');
    if (option.dataset.value === toggle.dataset.waste) return;
    setWaste(toggle, option.dataset.value);
    option.focus({ preventScroll: true });
    render(root, true);
  });

  document.addEventListener('keydown', event => {
    const option = event.target.closest('.ProductBoxExpanded[data-pack-price] .calc-toggle__opt');
    if (!option) return;
    const keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
    if (!keys.includes(event.key)) return;
    event.preventDefault();
    const toggle = option.closest('.calc-toggle');
    const root = toggle.closest('.ProductBoxExpanded');
    const next = toggle.dataset.waste === 'true' ? 'false' : 'true';
    setWaste(toggle, next);
    toggle.querySelector(`.calc-toggle__opt[data-value="${next}"]`).focus({ preventScroll: true });
    render(root, true);
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
